import React from 'react';

import securePayment from '@images/PaymentProcessing/securePayment.png';
import form from '@images/PaymentProcessing/form.png';

const CardNotPresent: React.FC = () => {
	return <section className="card-not-present payments-processing__item">
		<div className="card-not-present__container payments-processing__container">
			<div className="card-not-present__image image-block">
				<div className="image-block__img secure-payment-img">
					<img src={securePayment} alt="Secure payment" />
				</div>
				<div className="image-block__img form-img">
					<img src={form} alt="Form" />
				</div>
			</div>
			<div className="card-not-present__text-block text-block">
				<h1 className="text-block__title">Card Not Present</h1>
				<ul className="text-block__list">
					<li>Hosted secure card form</li>
					<li>Ability to securely store card and bank accounts</li>
					<li>Apple and Google digital wallets</li>
				</ul>
				<a href="/payments-processing#request-demo" className="text-block__link">request a demo</a>
			</div>
		</div>
	</section>;
};

export default CardNotPresent;
